module.exports = __webpack_public_path__ + "static/media/Iqtisadiyyat_nazirliyil.2676c491.jpg";